import React, { useState, useRef } from "react";
import Form from "react-validation/build/form";
import Modal from "react-bootstrap/Modal";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { Grid, Input, MenuItem, Select, InputLabel } from "@mui/material";
import { Button } from "@mui/material";
import CountrySelect from "../../CountrySelect";
import {  useSelector } from "react-redux";

const UserModalForm = ({
    isModal,
    displayedUser,
    onHide,
    handleSubmit,
    setActive, active,
    setFirstName, firstname,
    setLastName, lastname,
    setType, type,
    address_one, setAddressOne,
    address_two, setAddressTwo,
    zipcode, setZipCode,
    country, setCountry,
    email, setEmail,
    phonenumber, setPhoneNumber,
    locality, setLocality,
    password, setPassword,
    password2, setPassword2,
    id_agency, set_id_agency,
    id_center, set_id_center,
    listAgencies,
    listCenters,
    setTitleType }) => {


    const { user: currentUser } = useSelector((state) => state.auth);

    const form = useRef();

    const onChangeType = (newType) => {
        if (newType === 1) {
            set_id_agency(null);
            set_id_center(null);
        }
        if (newType === 2) {
            set_id_agency(null);
        }
        if (newType === 3 || newType === 4) {
            set_id_center(null);
        }
        setType(newType);
    };

    const handleSelectChange = (id) => {
        if (type === 2) {
            set_id_center(id);
            set_id_agency(null);
        }
        if (type === 3 || type === 4) {
            set_id_agency(id);
            set_id_center(null);
        }
    }

    const getTextFromType = (val) => {
        switch (Number(val)) {
            case 1:
                return "Admin";
            case 2:
                return "Centre Manager";
            case 3:
                return "Agency leader";
            case 4:
                return "Agent";
            default:
                return "Type";
        }
    };

    const compare = ( a, b ) => {
        if ( a.name < b.name ){
          return -1;
        }
        if ( a.name > b.name ){
          return 1;
        }
        return 0;
      }

    const getSelectFromType = () => {
        if (type === 1) {
            return (
                <>
                    <label style={{ color: "white" }}>{'l'}</label>
                    <Select value="0" disabled size="small" style={{ minWidth: '100%' }}>
                        <MenuItem value='0'>-</MenuItem>
                    </Select>
                </>
            )
        }
        if (type === 2) {
            return (
                <>
                    <label>Centre</label>
                    <Select size="small" value={id_center || 0} onChange={(e) => handleSelectChange(e.target.value)} style={{ minWidth: '100%' }}>
                        {listCenters != null && listCenters.sort(compare).filter(c => c.active).map((centerDTO) => (
                            <MenuItem value={centerDTO.id}>{centerDTO.name}</MenuItem>
                        ))}
                    </Select>
                </>
            )
        }
        if (type === 3 || type === 4) {
            return (
                <>
                    <label>Agency</label>
                    <Select size="small" value={id_agency || 0} onChange={(e) => handleSelectChange(e.target.value)} style={{ minWidth: '100%' }}>
                        {listAgencies != null && listAgencies.sort(compare).filter(a => a.active).map((agencyDTO) => (
                            <MenuItem value={agencyDTO.id}>{agencyDTO.name}</MenuItem>
                        ))}
                    </Select>
                </>
            )
        }
    }

    return (
        <Form onSubmit={handleSubmit} ref={form}>

            {isModal ? <Modal.Header closeButton>
                <Grid container>
                    <Grid item>
                        <Modal.Title>{displayedUser ? "Edit" : "Create"} User</Modal.Title>
                    </Grid>
                </Grid>
                <FormControlLabel control={<Switch checked={active} onChange={(e) => setActive(e.target.checked)} />} />
            </Modal.Header> : <></>}

            <Modal.Body>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <label htmlFor="firstname">First Name</label>
                        <Input type="text" size="small" className="form-control" name="firstname" value={firstname} onChange={(e) => setFirstName(e.target.value)} readOnly={!(currentUser.type == 1 || currentUser.type == 3)} />
                    </Grid>
                    <Grid item xs={6}>
                        <label htmlFor="lastname">Last Name</label>
                        <Input type="text" className="form-control" name="lastname" size="small" value={lastname} onChange={(e) => setLastName(e.target.value)} readOnly={!(currentUser.type == 1 || currentUser.type == 3)} />
                    </Grid>

                    {currentUser.type == 1 &&
                        <>
                            <Grid item xs={6}>
                                <label htmlFor="type">Type</label>
                                <Select size="small" style={{ minWidth: '100%' }} value={type || 0} onChange={(e) => onChangeType(e.target.value)} >
                                    <MenuItem value={1}>Admin</MenuItem>
                                    <MenuItem value={2}>Centre Manager</MenuItem>
                                    <MenuItem value={3}>Agency leader</MenuItem>
                                    <MenuItem value={4}>Agent</MenuItem>
                                </Select>
                            </Grid>
                            <Grid item xs={6}>
                                {getSelectFromType()}
                            </Grid>
                        </>
                    }
                    <Grid item xs={6}>
                        <label htmlFor="address">Address</label>
                        <Input type="text" className="form-control" name="address" size="small" value={address_one} onChange={(e) => setAddressOne(e.target.value)} />
                    </Grid>
                    <Grid item xs={6}>
                        <label htmlFor="address2">Additional address</label>
                        <Input type="text" size="small" className="form-control" name="address2" value={address_two} onChange={(e) => setAddressTwo(e.target.value)} />
                    </Grid>
                    <Grid item xs={6}>
                        <label htmlFor="locality">Locality</label>
                        <Input type="text" className="form-control" size="small" name="locality" value={locality} onChange={(e) => setLocality(e.target.value)} />
                    </Grid>
                    <Grid item xs={3}>
                        <label htmlFor="zip_code">ZIP code</label>
                        <Input type="text" size="small" className="form-control" name="zipcode" value={zipcode} onChange={(e) => setZipCode(e.target.value)} inputProps={{ min: 0, style: { textAlign: 'center' } }} />
                    </Grid>
                    <Grid item xs={3}>
                        <label htmlFor="country">Country</label>
                        <CountrySelect setValue={setCountry} selectedCode={country} />
                    </Grid>
                    <Grid item xs={6}>
                        <label htmlFor="email">Email address</label>
                        <Input type="text" className="form-control" name="email" size="small" value={email} onChange={(e) => setEmail(e.target.value)} />
                    </Grid>
                    <Grid item xs={6}>
                        <label htmlFor="phonenumber">Phone Number</label>
                        <Input size="small" type="text" className="form-control" name="phonenumber" value={phonenumber} onChange={(e) => setPhoneNumber(e.target.value)} />
                    </Grid>
                    <Grid item xs={6}>
                        <div style={(!isModal || displayedUser == null) ? { display: "block" } : { display: "none" }}>
                            <label htmlFor="password">New Password</label>
                            <Input type="password" className="form-control" name="password" size="small" value={password} onChange={(e) => setPassword(e.target.value)} />
                        </div>
                    </Grid>
                    <Grid item xs={6}>
                        <div style={(!isModal || displayedUser == null) ? { display: "block" } : { display: "none" }}>
                            <label htmlFor="password">Confirm Password</label>
                            <Input type="password" className="form-control" name="password" size="small" value={password2} onChange={(e) => setPassword2(e.target.value)} />
                        </div>
                    </Grid>
                </Grid>
            </Modal.Body>
            <Modal.Footer>
                <Grid container spacing={3}>
                    {isModal ?
                        <Grid item xs={6}>
                            <Button variant="outlined" onClick={onHide} sx={{ width: '100%' }}>Close</Button>
                        </Grid> : <></>}
                    <Grid item xs={6}>
                        <Button variant="contained" onClick={handleSubmit} sx={{ width: '100%' }}>
                            Save
                        </Button>
                    </Grid>

                </Grid>
            </Modal.Footer>

        </Form>
    )
};

export default UserModalForm;